import { Reveal } from './Reveal';
import { MapPinned, Landmark, BadgeCheck, ShieldCheck, Asterisk } from 'lucide-react';

const BADGES = [
  { icon: MapPinned, title: 'Pan-India Coverage', sub: 'All States & UTs' },
  { icon: Landmark, title: 'Virtual Court & Lok Adalat', sub: 'Specialists' },
  { icon: BadgeCheck, title: '10,000+ Challans Disposed', sub: 'Legally settled' },
  { icon: ShieldCheck, title: 'Govt Portal Verified Flow', sub: 'Parivahan synced' },
];

const CITIES = [
  'Delhi', 'Mumbai', 'Bengaluru', 'Hyderabad', 'Chennai', 'Kolkata', 'Pune', 'Lucknow',
  'Jaipur', 'Ahmedabad', 'Gurugram', 'Noida', 'Indore', 'Chandigarh', 'Kochi', 'Nagpur',
  'Bhopal', 'Patna', 'Surat', 'Pan-India Service',
];

export default function TrustBar() {
  return (
    <section className="relative bg-[#F8FAFC] -mt-6" data-testid="trust-bar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4 lg:gap-6 rounded-2xl bg-white border border-slate-200/80 shadow-xl shadow-slate-200/60 p-4 sm:p-6 -translate-y-8">
          {BADGES.map(({ icon: Icon, title, sub }, i) => (
            <Reveal key={title} delay={i * 0.08}>
              <div
                className="flex items-center gap-3.5 h-full rounded-xl px-3 py-2 hover:bg-slate-50 transition-colors"
                data-testid={`trust-badge-${i}`}
              >
                <span className="shrink-0 inline-flex items-center justify-center w-11 h-11 rounded-xl bg-brand-blue/10 text-brand-blue border border-brand-blue/10">
                  <Icon size={20} strokeWidth={2.2} />
                </span>
                <span>
                  <span className="block text-[13px] sm:text-sm font-bold text-brand-ink leading-tight">{title}</span>
                  <span className="block text-[11px] font-semibold text-slate-400 mt-0.5">{sub}</span>
                </span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>

      <div className="bg-brand-blue py-4 mt-2 overflow-hidden marquee" data-testid="trust-marquee">
        <div className="marquee-track items-center gap-0">
          {[0, 1].map((copy) => (
            <div key={copy} className="flex items-center shrink-0" aria-hidden={copy === 1}>
              {CITIES.map((city) => (
                <span key={`${copy}-${city}`} className="flex items-center shrink-0">
                  <span className="font-display text-lg sm:text-xl font-semibold uppercase tracking-wide text-white/90 px-5">
                    {city}
                  </span>
                  <Asterisk size={18} className="text-brand-orange shrink-0" />
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
